import { useState } from "react";
import { X } from "lucide-react";

export const AnnouncementBanner = () => {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div data-testid="announcement-banner" className="bg-[#c9a84c] relative z-[60] pointer-events-none">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-2.5 flex items-center justify-center">
        <p
          className="text-[12px] md:text-[13px] text-[#1a1d2e] tracking-[0.05em] text-center"
          style={{ fontFamily: "'DM Sans', sans-serif" }}
        >
          <span className="font-medium">VTC29</span> devient{" "}
          <span className="font-bold">Van d'Iroise</span>{" "}
          <span className="hidden sm:inline">— Chauffeur Privé · Brest · Bretagne</span>
        </p>
        <button
          data-testid="announcement-banner-close"
          onClick={() => setVisible(false)}
          className="absolute right-4 md:right-6 p-1 text-[#1a1d2e]/60 hover:text-[#1a1d2e] transition-colors pointer-events-auto"
          aria-label="Fermer"
        >
          <X size={14} strokeWidth={2} />
        </button>
      </div>
    </div>
  );
};
